import React from "react";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Col, Row, Container } from "react-bootstrap";
import ShippingLeftSideNav from "./Views/LeftSideNav/ShippingLeftSideNav";
import LocationDetails from "./Views/LocationDetails";
import * as _ from "../../constants/Constants";
import { checkUserRoles } from "../../utils/utils";
import RightNotes from "../VendorOnboarding/Views/RightNotes/RightNotes";
import { useVendorProfileLoader } from "../Common/CustomHooks/useVendorProfileLoader";
import ShippingLocationDetails from "./Views/ShippingLocationDetails/ShippingLocationDetails";
import RoutingRequest from "./RoutingRequest";
import { verifyAccessPermission } from "../../utils/rolePermissionAccess";

const ShippingContainer = (props) => {
  const history = useHistory();
  useVendorProfileLoader(); //To restore VendorProfile details in redux store on page reload

  const pageType = props.match.params?.type;
  const pathname = props.location.pathname;
  const store = useSelector(
    ({ service, common }) => ({
      fetching: service.fetching,
      vendorProfileId: service.vendorProfile?.vendorDetail?.id || "",
      vendorDetails: service.vendorProfile?.vendorDetail,
      profileId: common.profileId,
      notes: service.notes,
      externalVendorEmail: common?.externalVendorEmail,
      onboardingStatus: common.boardingStatuses?.onboardingStatus,
      roleName: service.roles?.roleName,
      vendorStatus: service.vendorStatus || [],
      extUserEnabled: verifyAccessPermission("extUserEnabled")
        ? service?.vendorProfile && service?.vendorProfile?.primaryContact
          ? true
          : false
        : true,
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
    }),
    shallowEqual
  );

  return (
    <Container
      fluid
      style={{
        padding: 0,
      }}
    >
      <Row style={{ padding: 0 }}>
        <Col xs={12} sm={6} md={4} xl={3} xxl={3} style={{ padding: 0 }}>
          <ShippingLeftSideNav params={props.match.params} />
        </Col>
        <Col
          xs={12}
          sm={12}
          md={8}
          xl={7}
          xxl={7}
          className="onboarding_centerArea"
        >
          {((pageType === _.SHIPPING && pathname.includes("shipping")) ||
            (!pageType && pathname.includes("shipping"))) && (
            <ShippingLocationDetails history={history} />
          )}

          {pageType === _.SHIPPING_LOCATION &&
            pathname.includes("shipping") && (
              <LocationDetails
                history={props.history}
                extUserEnabled={store.extUserEnabled}
                merchandiseType={store.merchandiseType}
                vendorProfileId={store.profileId}
              />
            )}

          {pathname.includes("routing") && (
            <RoutingRequest
              history={props.history}
              extUserEnabled={store.extUserEnabled}
              merchandiseType={store.merchandiseType}
              vendorProfileId={store.profileId}
            />
          )}
        </Col>
        {store?.notes?.length > 0 && !pathname.includes("brand") && (
          <Col xs={12} sm={6} md={4} xl={2} xxl={2} style={{ paddingRight: 0 }}>
            <div className="rightNotes">
              {verifyAccessPermission("viewRightNotes") && (
                <RightNotes notes={store.notes} />
              )}
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default ShippingContainer;
